import io from 'socket.io-client';
import SessionService from './SessionService';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
const socketApiUrl = `${apiBaseUrl}?token=${SessionService.getAccessToken()}`;
const socket = io(socketApiUrl, {
  transports: ['websocket', 'polling'],
});

export default socket;
